/**
 * AddParametricAssetCommand - Command for adding parametric assets with undo/redo support.
 *
 * Manages multiple entities created by a parametric asset.
 * Uses soft-delete pattern (move to hidden layer) for undo.
 */

import type { DRDrawingViewer } from "../DRDrawingViewer";
import { BaseAddEntityCommand } from "./BaseAddEntityCommand";

/**
 * Parameters for AddParametricAssetCommand.
 */
export interface AddParametricAssetParams {
  /** The asset identifier */
  assetId: string;
  /** Parameter values used to build the asset */
  values: Record<string, number | boolean>;
  /** Handles of created entities (stable identifiers) */
  entityHandles: string[];
  /** Original layer name for all entities */
  originalLayerName: string;
}

/**
 * Command for adding parametric assets with undo/redo support.
 *
 * Uses soft-delete pattern: entities are moved to a hidden layer on undo
 * rather than being permanently deleted, allowing for redo.
 */
export class AddParametricAssetCommand extends BaseAddEntityCommand {
  private assetId: string;
  private values: Record<string, number | boolean>;

  constructor(viewer: DRDrawingViewer, params: AddParametricAssetParams) {
    super(viewer, {
      entityHandles: params.entityHandles,
      originalLayerName: params.originalLayerName,
    });
    this.assetId = params.assetId;
    this.values = params.values;
  }
}
